var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-row"},[_c('basic-checkbox',{attrs:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event)}}}),_c('div',{staticClass:"table-row-name"},[_vm._v(_vm._s(_vm.table.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }